export default [
  {
    path: '',
    component: 'Layout',
    children: [
      {
        path: '/',
        name: 'Index',
        meta: { title: '首页', icon: 'home' }
      }
    ]
  },
  {
    path: '/resource',
    component: 'Layout',
    children: [
      {
        path: 'folder',
        name: 'ResourceFolder',
        meta: { title: '仓库管理', icon: 'resource' }
      }
    ]
  },
  {
    path: '/mendian',
    component: 'Layout',
    children: [
      {
        path: 'list',
        name: 'MendianList',
        meta: { title: '团队管理', icon: 'customer' }
      }
    ]
  },
  {
    path: '/customer',
    component: 'Layout',
    children: [
      {
        path: 'order',
        name: 'CustomerOrder',
        meta: { title: '订单管理', icon: 'customer' }
      }, {
        path: 'layout',
        name: 'CustomerLayout',
        hidden: true,
        meta: { title: '排版', icon: 'customer' }
      }
    ]
  },
   {
    path: '/customer',
    component: 'Layout',
    children: [
      {
        path: 'orderadd',
        name: 'CustomerOrderadd',
        meta: { title: '新增加订单', icon: 'resource' }
      }
    ]
  },
]
